const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const isMobileWitdh = width < 993;

export default isMobileWitdh;



// WEBPACK FOOTER //
// ./src/app/helpers/isMobile.js